import { AutocompleteSelect, AutocompleteSelectProps, TBaseItem } from "@centricsoftware/design-system";
import { useEffectAsync, useSyncLocalStore } from "designSystem/hooks";
import { useLocale } from "designSystem/locale";
import { observer } from "mobx-react-lite";
import React, { FC } from "react";
import { CLEAR_RES, OPEN_RES } from "csi/components/constants";
import { ISingleSelectOptionStore } from "../types";
import { isSelectValueEmpty } from "./selectUtility";
import SingleSelectOptionManager from "./store/SingleSelectOptionManager";

export interface SingleSelectWithOptionStoreProps 
	extends Omit<
		AutocompleteSelectProps<TBaseItem>, 
		"clearButtonAriaLabel" | 
		"dropdownButtonAriaLabel" | 
		"noOptionsLabel" | 
		"options"
	> {
	/** indicates to query data store and select value if only one result */
	autofillIfOne?: boolean;

	/** store to query for options */	
	optionsStore: ISingleSelectOptionStore;
}

export const SingleSelectWithOptionStore: FC<SingleSelectWithOptionStoreProps> = observer((props) => {
	const { autofillIfOne, onChange, optionsStore, value, ...otherProps } = props;
	const loc = useLocale();
	const store = useSyncLocalStore(() => new SingleSelectOptionManager(loc));
	const { isLoading, onOpen, options, refresh } = store;

	useEffectAsync(async (): Promise<void> => {
		refresh(optionsStore, value);

		if (autofillIfOne && isSelectValueEmpty(value)) {
			await onOpen();

			if (store.options?.length === 1) {
				// FIX: is it ok to pass a null event?
				onChange?.(null, store.options[0], "selectOption");
			}
		}
	}, [optionsStore]);
	
	// TODO: no support for Go to Dialog yet

	return (
		<AutocompleteSelect<TBaseItem>
			clearButtonAriaLabelRes={CLEAR_RES}
			dropdownButtonAriaLabelRes={OPEN_RES}
			isLoading={isLoading}
			onChange={onChange}
			onOpen={onOpen}
			options={options ?? []}
			value={value}
			{...otherProps}
		/>
	);
});
